import React, { Component } from 'react';

import ListTable from 'components/common/ListTable';
import { getSalePlansStat } from 'actions/asyncActions';
import { defaultShopPlansFilter, ShopsPlansFilter } from 'filters/PlansFilter';
import planColumns from '../planColumns';
import CacheDate from './CacheDate';

@planColumns
export default class ShopPlans extends Component {
    getColumns() {
        return [
            {
                title: 'Магазин',
                dataIndex: ['_embedded', 'shop', 'name'],
                key: 'shop',
                fixed: 'left',
                width: 120
            }, {
                title: 'Сеть',
                dataIndex: ['_embedded', 'network', 'name'],
                key: 'network',
                fixed: 'left',
                width: 120
            }, {
                title: 'Регион',
                dataIndex: ['_embedded', 'region', 'name'],
                key: 'region',
                fixed: 'left',
                width: 120
            },
            {
                title: 'Проект',
                dataIndex: ['_embedded', 'productDepartment', 'name'],
                fixed: 'left',
                width: 120,
                key: 'productDepartment'
            },
            ...this.props.planColumns
        ];
    }

    render() {
        const { saga, setDate, planDate } = this.props;

        return (
            <ListTable
                tableColumns={this.getColumns()}
                action={getSalePlansStat}
                filterForm={ShopsPlansFilter}
                initialFilters={{
                    ...defaultShopPlansFilter,
                    date: planDate
                }}
                scroll={{ x: 'max-content' }}
                className='th-multi'
                saga={saga}
                setDate={setDate}
                setProductDepartments={this.props.setProductDepartments}
                staticPayload={{ limit: 0 }}
                hidePagination
                bordered
                footer={({ _meta }) => <CacheDate meta={_meta} /> }
            />
        );
    }
}
